// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QExp","tabsBox":"styles_tabsBox__3phn0","createButton":"styles_createButton__1wgvV"};